import { responseStatus } from '../constants';
import { ApiPaths } from '../helpers/api';
import { QuyLuongInfo } from '../models/luong/QuyLuong';
import intance from '../utils/axios';

export const layDanhSachQuyLuong = async (): Promise<QuyLuongInfo[]> => {
    let rs: QuyLuongInfo[] = [];
    await intance
        .get(ApiPaths.quyLuong.layDanhSach)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu ?? [];
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};

export const layQuyLuongTheoNam = async (nam: number): Promise<QuyLuongInfo | null> => {
    let rs: QuyLuongInfo | null = null;
    await intance
        .get(`${ApiPaths.quyLuong.layTheoNam}?nam=${nam}`)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};

export const luuQuyLuong = async (request: any): Promise<number> => {
    let rs = 0;
    await intance
        .post(ApiPaths.quyLuong.luu, request)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};

export const xoaQuyLuong = async (id: number): Promise<void> => {
    await intance
        .delete(`${ApiPaths.quyLuong.xoa}/${id}`)
        .then((res) => {
            if (res.data.trangThai !== responseStatus.thanhCong) {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
};
